import { useState } from "react";

export type ActiveType = "text" | "text_box_settings" | "icon" | "padding";

export const useBottomMenu = () => {
    const [activeType, setActiveType] = useState<ActiveType | null>(null);
    const isPopupOpen = !!activeType;

    const openPopup = (type: ActiveType) => {
        if (activeType === type) {
            closePopup();
            return;
        }

        setActiveType(type);
    };
    const closePopup = () => {
        if (activeType === "text_box_settings") return;
        setActiveType(null);
    };

    return { isPopupOpen, openPopup, closePopup, activeType };
};
